














import { Component, Vue } from "vue-property-decorator";
import EstimatePurchaseRow from "./EstimatePurchaseRow.vue";
import VTh from "./VTh.vue";

@Component({
  components: {
    VTh,
    EstimatePurchaseRow
  }
})
export default class PurchaseOptionHeader extends Vue {}
